import React, { Component } from 'react';
import clazz from 'classnames';
import styles from './index.module.less';
import { MujiLink } from '@souche-f2e/muji';

class RightContent extends Component {
  render() {
    const { className, style, routeTo, content} = this.props;
    return (
      <div className={clazz(className, styles.rightContent)} style={style}>
        <MujiLink to={routeTo}>{content}</MujiLink>
      </div>
      )
  }
}

export default RightContent;
